import { render } from "./ComplianceSuccess.vue?vue&type=template&id=78c28e8d&scoped=true"
import script from "./ComplianceSuccess.vue?vue&type=script&lang=js"
export * from "./ComplianceSuccess.vue?vue&type=script&lang=js"

import "./custom-compliance-success.scss?vue&type=style&index=0&id=78c28e8d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c28e8d"]])

export default __exports__